module.exports = __webpack_public_path__ + "static/media/photo_video.4f067685.jpg";